import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    title: yup
        .string()
        .required('Поле обязательно')
        .max(100, 'Заголовок не должен содержать более 100 символов'),
});
